<header class="header">
  <h2 class="title">{{ 'table.algorithms.switch_algorithm_dialog.title' | translate }}</h2>
</header>

<ng-container *ngIf="data$ | async as data">
  <section class="body">
    <p
      class="description"
      [innerHTML]="
        'table.algorithms.switch_algorithm_dialog.description'
          | translate
            : {
                pipelineName: (pipelineName$ | async),
                pipelineStepId: data.pipelineStepId
              }
      "
    ></p>

    <ts-algorithm-usage-grid class="usage-grid" [organizations]="data.pipelineUsage"></ts-algorithm-usage-grid>

    <ts-algorithm-switcher class="switcher"></ts-algorithm-switcher>
  </section>

  <footer class="actions">
    <button #btnCancel class="btn widget cancel-button" (click)="cancel()" data-cy="cancel-button">
      {{ 'button.cancel' | translate }}
    </button>
    <button
      #btnAccept
      class="btn widget btn-primary"
      color="primary"
      (click)="accept()"
      [disabled]="(readyToSwitch$ | async) === false"
      data-cy="confirm-button"
    >
      {{ 'button.confirm' | translate }}
    </button>
  </footer>
</ng-container>
